/* eslint-disable no-useless-escape */
export const URL_REG_EXP =
  /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/;
export const TITLE = 'Математика Плюс';
export const ADVANCED_MATH_URL = 'https://uchi.ru/advanced-math';
